// extracted by mini-css-extract-plugin
export var standaloneTable = "_1f-0";
export var standaloneTableWithBodyFill = "_1f-1";
export var withExtraHeader = "_1f-2";